module.exports = __webpack_public_path__ + "static/media/wicked_city.755a7e9b.gif";